// Product form width handler
window.T4SThemeSP = window.T4SThemeSP || {};

T4SThemeSP.ProductFormWidth = (function () {
  function updateAddToCartWidth() {
    const formContainer = document.querySelector('.t4s-product__price-review');
    const mainProductAddToCart = document.querySelector('.main-product-add-to-cart');

    if (formContainer && mainProductAddToCart) {
      const formContainerWidth = formContainer.offsetWidth;
      // 120 is the size of .t4s-product-form__buttons .t4s-quantity-wrapper
      // Only subtract 120 if quantity wrapper is shown
      const quantityWrapper = document.querySelector('.t4s-quantity-wrapper');
      // -20 is because  mainProductAddToCart.style.width = `${adjustedWidth - 20}px`; 
      const quantityWidth = quantityWrapper ? 120 : -20;
      const adjustedWidth = formContainerWidth - quantityWidth;

      // show it 
      mainProductAddToCart.style.opacity = 1;
      // Handle responsive layout
      if (window.innerWidth > 768) {
        requestAnimationFrame(() => {
          mainProductAddToCart.style.width = `${adjustedWidth - 20}px`; // minus 20 for padding
          // mainProductAddToCart.style.right = `-${adjustedWidth}px`;
        });
      } else {
        mainProductAddToCart.style.position = 'relative';
        mainProductAddToCart.style.right = 'auto';
        requestAnimationFrame(() => {
          mainProductAddToCart.style.width = `${formContainerWidth}px`;
        });
      }
    }
    // on the mobile , click it once
    // 这是因为如是不这样做的话，第一次点击不会生效
    // if (window.innerWidth < 768) {
    //   const mini_cart=document.querySelector('.t4s-sticky-atc.is--shown')
    //   const visibility=window.getComputedStyle(mini_cart).visibility
    //   if(visibility=='hidden'){
    //     setTimeout(() => {
    //       mainProductAddToCart.click();
    //     }, 3000)
    //   }
    // }
  }

  function updateFrequentlyBoughtTogetherHeight() {
    // this is because the include with purchase is absolute, we need set the parent size manually
    const includeWithPurchase = document.querySelector('.include-with-purchase');
    console.log('updateFrequentlyBoughtTogetherHeight', includeWithPurchase)
    if (includeWithPurchase) {
      // 兼容性更好的是document.querySelectorAll('.t4s-container.t4s-main-product__content')
      // 不过暂时可以满足就行了。
      const frequentlyBoughtTogether = document.querySelector('.frequently-bought-together');
      if (frequentlyBoughtTogether) {
        // compare height with include with purchase,if purchase is higher than frequentlyBoughtTogether
        if (includeWithPurchase.offsetHeight > frequentlyBoughtTogether.offsetHeight) {
          frequentlyBoughtTogether.style.height = `${includeWithPurchase.offsetHeight}px`;
        }
      } else {
        const parent = includeWithPurchase.parentNode;
        console.log('updateFrequentlyBoughtTogetherHeight', parent.offsetWidth, includeWithPurchase.offsetHeight)
        parent.style.height = `${parent.offsetWidth + includeWithPurchase.offsetHeight + 100}px`;
      }
    }
  }



  // Add window resize listener with RAF for better performance
  let rafId;
  function handleResize() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(updateAddToCartWidth);
  }

  // function handleAddToCart() {
  //   const addToCartButton = document.querySelector('.main-product-add-to-cart');
  //   if (addToCartButton) {
  //     addToCartButton.addEventListener('click', function (e) {
  //       console.log("here you click", e)
  //       e.preventDefault();
  //       // Find the closest form element
  //       // document.querySelector('.t4s-sticky-atc__atc.t4s-btn-loading__svg').click()
  //       // this is because on the mobile , you must click two times for real commit
  //       let proudctShow = document.querySelector('.t4s-sticky-atc__product')
  //       if (proudctShow.style.display === 'none' || proudctShow.style.display === '') {
  //         document.querySelector('.t4s-sticky-atc__atc.t4s-btn-loading__svg').click()
  //       }
  //     });
  //   }
  // }

  function collapseLearnMore() {
    // Check if the learn-more-text element exists
    const infoList = document.querySelector('.learn-more-text');
    if (!infoList) return;


    // Check if the learn more button already exists, if not create it
    let learnMoreBtn = document.querySelector('.t4s__learn-more-btn');
    if (!learnMoreBtn) {
      learnMoreBtn = document.createElement('div');
      learnMoreBtn.className = 't4s__learn-more-btn';
      learnMoreBtn.textContent = 'Learn More';

      // Insert the button after the learn-more-text element
      if (infoList.parentNode) {
        infoList.parentNode.insertBefore(learnMoreBtn, infoList.nextSibling);
      }
    }

    // Add CSS styles directly to match the design
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .t4s-pr__richtext.learn-more-text {
        max-height: 100px;
        overflow: hidden;
        position: relative;
        transition: max-height 0.3s ease;
        margin-bottom: 0px;
      }
      .t4s-pr__richtext.learn-more-text p {
      line-height: 1.6;
      }
      
      .learn-more-text.expanded {
        max-height: 2000px; /* Large enough to show all content */
      }
      
      .learn-more-text.show-gradient:not(.expanded)::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
        pointer-events: none;
      }
      
      .t4s__learn-more-btn {
        display: none;
        color: #00C7C7;
        font-weight: 500;
        cursor: pointer;
        margin-top: 8px;
        font-size: 16px;
        font-family: Montserrat;
        line-height: 20px;
        vertical-align: middle;
        text-transform: capitalize;
      }
      
      .t4s__learn-more-btn::after{
        content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDcuNUwxMCAxMi41TDUgNy41IiBzdHJva2U9IiMwMEM3QzciIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=);
        margin-left: 6px;
        display: inline-flex;
        transform: translateY(5px);
      }
        
    `;
    document.head.appendChild(styleElement);

    // Only show the button if content exceeds max height
    if (infoList.scrollHeight > 120) {
      infoList.style.marginBottom = '0px';
      learnMoreBtn.style.display = 'block';
      learnMoreBtn.style.marginTop = '0px';
      infoList.classList.add('show-gradient');
    } else {
      learnMoreBtn.style.display = 'none';
      infoList.classList.remove('show-gradient');
    }

    function toggleLearnMore() {
      const wrapper = document.querySelector('.t4s-pr__richtext.learn-more-text');

      if (wrapper.classList.contains('expanded')) {
        wrapper.classList.remove('expanded');
        learnMoreBtn.textContent = 'Learn More';

        // Scroll back to the top of the content if needed
        const rect = wrapper.getBoundingClientRect();
        if (rect.top < 0) {
          wrapper.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        wrapper.classList.add('expanded');
        learnMoreBtn.style.transition= 'all .1s ease';
        learnMoreBtn.style.opacity= '0';
        setTimeout(() => {
          learnMoreBtn.style.display = 'none';
        }, 200);
        infoList.classList.remove('show-gradient');
      }
    }
    learnMoreBtn.addEventListener('click', toggleLearnMore);

    // Remove any existing event listeners before adding a new one
    // const newLearnMoreBtn = learnMoreBtn.cloneNode(true);
    // learnMoreBtn.parentNode.replaceChild(newLearnMoreBtn, learnMoreBtn);
    // newLearnMoreBtn.addEventListener('click', toggleLearnMore);
  }

  function initHooks() {
    updateAddToCartWidth();
    collapseLearnMore();
    // handleAddToCart();
    // updateFrequentlyBoughtTogetherHeight();
  }

  function init() {
    // Initial setup
    document.addEventListener('DOMContentLoaded', initHooks);

    // Shopify specific events
    document.addEventListener('shopify:section:load', initHooks);
    document.addEventListener('shopify:block:select', initHooks);

    // Window resize
    window.addEventListener('resize', handleResize);

    // Run immediately if DOM is already loaded
    if (document.readyState === 'complete') {
      initHooks();
    }
  }

  return {
    init: init,
  };
})();

// Initialize the module
T4SThemeSP.ProductFormWidth.init();
